import { getLocalVariant } from '@/utils/abtest.utils'

const GET_CURRENT_USER_ACTION = 'getCurrentUserAction'

/**
 * Vuex plugin to sync Auth UI A/B test variant to backend
 *
 * This plugin listens to the getCurrentUserAction (after user is loaded)
 * and automatically syncs the auth UI variant from localStorage to backend
 * by patching the user's personalInformation.
 */
const localStorageABTestPlugin = (store) => {
  store.subscribeAction({
    after: async (action) => {
      // Only handle getCurrentUserAction - ensures user is already loaded
      if (action.type !== GET_CURRENT_USER_ACTION) {
        return
      }

      const { currentUser } = store.state

      // Only sync if user is logged in
      if (!currentUser || !currentUser.id) {
        return
      }

      // Skip if uiVariant already exists in personalInformation
      // This prevents unnecessary API calls on subsequent app loads
      if (
        currentUser.personalInformation &&
        currentUser.personalInformation.uiVariant
      ) {
        return
      }

      const variant = getLocalVariant('UI_VARIANT')

      if (!variant) {
        return
      }

      store.dispatch('patchCurrentUserAction', {
        userId: currentUser.id,
        personalInformation: {
          uiVariant: variant,
        },
      })
    },
  })
}

export default localStorageABTestPlugin
